import React from "react";
import "./styles/index.scss";
import Delimiter from "../../common/forms/delimiter/Delimiter";
import DoneIcon from "../../common/icons/doneIcon";
import { clickToLinkHandler } from "../../../helpers/utils";

const RecoverSuccessForm = () => {
  return (
    <React.Fragment>
      <div className="recover-success-form-container">
        <div className="title-container">
          <DoneIcon />
          <div className="title">Check Your Email</div>
        </div>
        <Delimiter type="headline" shift="18" />
        <div className="description">
          A password reset email has been sent to the provided email address if
          its associated with a Dealkit account.
        </div>
        <Delimiter type="internal" shift="18" />
        <div className="links-container">
          <div
            className="link"
            onClick={() => {
              clickToLinkHandler("/");
            }}
          >
            Reload Page
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RecoverSuccessForm;
